// height of value in multi-select dropdown
export var DROPDOWN_MULTI_VALUE_HEIGHT = {
  xs: '28px',
  md: '30px',
  xl: '36px'
}; // icon size of value in multi-select dropdown

export var DROPDOWN_MULTI_VALUE_ICON_SIZE = {
  xs: '14px',
  md: '16px',
  xl: '18px'
}; // right margin for chips values in multiselect dropdown

export var DROPDOWN_MULTI_VALUE_RIGHT_MARGIN = {
  xs: '6px',
  md: '6px',
  xl: '8px'
}; // size of vertical padding in multiselect dropdown

export var DROPDOWN_MULTI_VERTICAL_PADDING = '4px';
export var DROPDOWN_MULTI_HEIGHT = {
  xs: '36px',
  md: '40px',
  xl: '46px'
};
export var DROPDOWN_OPTION_HEIGHT = {
  xs: 38,
  md: 42,
  xl: 44
};
export var DROPDOWN_MENU_MIN_WIDTH = 260;
export var DROPDOWN_MENU_OPTIONS_MIN_VISIBLE_COUNT = 1;
export var DROPDOWN_MENU_OPTIONS_MAX_VISIBLE_COUNT = 10;
export var DROPDOWN_MENU_OPTIONS_MAX_DEFAULT_COUNT = 6;
export var DROPDOWN_MENU_OPTIONS_MIN_DEFAULT_COUNT = 3;